import moment from "moment";
import axios from "axios";

export default {
    methods: {
        $_emApiMixin_findByFilter(entity, queryForm) {
            let api = `${this.$_emApiMixin_entityBaseApi(entity)}/findByFilter`;
            let _this = this
            return new Promise((resolve, reject) => {
                _this.$_emApiMixin_post(api, queryForm).then(response => resolve(response.data.list ? response.data.list : {}))
            })
        },
        $_emApiMixin_dateFormat(date) {
            return moment(date).format(
                this.$t("em.datetime.format.viewMode"))
        },
        $_emApiMixin_moduleBaseApi(entity) {
            return `${this.$store.state[entity].baseModuleUrl}`
        },
        $_emApiMixin_entityBaseApi(entity) {
            return `${this.$store.state[entity].baseModuleUrl}/${entity}`
        },
        $_emApiMixin_get(api, commonErrorHandle) {
            return this.$store.dispatch("api/get", {url: api, commonErrorHandle: commonErrorHandle})
        },
        $_emApiMixin_post(api, requestBody, commonErrorHandle) {
            return this.$store.dispatch("api/post",
                {
                    url: api,
                    data: requestBody,
                    commonErrorHandle: commonErrorHandle
                })
        },
        // api的put是专为修改entity写的，需要有url，entity和module，不是通用的东西，先不封装了
        $_emApiMixin_put(api, entity, module, commonErrorHandle) {
            return this.$store.dispatch("api/put",
                {
                    url: api,
                    entity,
                    module,
                    commonErrorHandle: commonErrorHandle
                })
        },
        $_emApiMixin_delete(api) {
            return this.$store.dispatch("api/delete", {url: api})
        }
    }
};